import { Lock } from 'lucide-react';
import { PercentageBadge } from './PercentageBadge';
import { useTranslation } from 'react-i18next';

interface LockedHabitCardProps {
  title: string;
  category: string;
  gain: string;
  gainType?: 'positive' | 'negative' | 'neutral';
  onUnlock?: () => void;
}

export function LockedHabitCard({ title, category, gain, gainType = 'positive', onUnlock }: LockedHabitCardProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div onClick={onUnlock} className={`w-full bg-stone-100/40 p-6 rounded-[2rem] border border-stone-200/50 flex items-center justify-between text-left opacity-60 relative overflow-hidden shadow-inner${onUnlock ? ' cursor-pointer' : ''}`}>
        {/* Lock Overlay */}
        <div className="absolute inset-0 bg-stone-100/30 backdrop-blur-[2px] z-10 flex items-center justify-center">
          <div className="bg-white/90 p-3.5 rounded-full shadow-[0_8px_30px_rgba(0,0,0,0.1)] border border-stone-200/50 backdrop-blur-md">
            <Lock className="w-5 h-5 text-stone-500" strokeWidth={2.5} />
          </div>
        </div>

        <div className="flex flex-col gap-1.5 opacity-40">
          <h3 className="text-[1.15rem] font-bold text-stone-900 tracking-tight">{title}</h3>
          <p className="text-sm font-medium text-stone-500">{category}</p>
        </div>

        <div className="flex items-center gap-4 opacity-40">
          <PercentageBadge value={gain} type={gainType} />
          <div className="w-8 h-8" /> {/* Placeholder for alignment */}
        </div>
      </div>

      <p className="text-[0.8rem] text-center text-stone-500 font-semibold tracking-wide px-6 leading-relaxed">
        {t('locked.message')}
      </p>
    </div>
  );
}
